export default __webpack_public_path__ + "static/media/komin-3.052aeff0.jpg";